import React from 'react';

const ArrowLeft = ({ size = 36, color = 'currentColor', ...other }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="이전 페이지로 가기"
      {...other}
    >
      <path
        d="M22.1673 4.21094L24.2886 6.33226L12.621 17.9989L24.2886 29.6662L22.1673 31.7875L9.43934 19.0596C8.89861 18.5195 8.85702 17.6686 9.31456 17.0802L9.45 16.9264L22.1673 4.21094Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowLeft;
